import React from 'react';
import BrandKitManager from '../components/brandkit/BrandKitManager';

export default function BrandKitPage() {
  return <BrandKitManager />;
}